import React, { useEffect, useState } from "react";
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import style from "../../../../styles/brsr/general.module.css";
import styles from "../../../../styles/common/brsrTable.module.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import EastIcon from "@mui/icons-material/East";
import { Add, Delete } from "@mui/icons-material";
import { get, put } from "../../../../utils/api";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate, useParams } from "react-router-dom";
import DeleteRowDialog from "../../../Common/DeleteRowDialog";
import { textError } from "../../../../utils/validationMessage";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const ReusableTable = ({ title, rows, columns, onChange, disabled }) => {
  return (
    <div>
      {title && <p className={styles.tableTitle}>{title}</p>}
      <TableContainer component={Paper} className={styles.tableContainer}>
        <Table className={styles.table}>
          <TableHead>
            <TableRow className={styles.tableHeader}>
              {columns.map((col, colIndex) => (
                <TableCell
                  key={colIndex}
                  className={styles.tableHeaderCell}
                  sx={{ width: col.width }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <TableCell
                    key={colIndex}
                    sx={{
                      borderRight:
                        colIndex !== columns.length - 1
                          ? "1px solid #ddd"
                          : "none",
                      backgroundColor:
                        typeof row.parameter === "string" &&
                        row.parameter
                          .toLowerCase()
                          .includes("total volume of water withdrawal") &&
                        (col.field === "currentFinancialYear" ||
                          col.field === "previousFinancialYear")
                          ? "#EFEFEF"
                          : "transparent",
                      pointerEvents:
                        typeof row.parameter === "string" &&
                        row.parameter
                          .toLowerCase()
                          .includes("total volume of water withdrawal") &&
                        (col.field === "currentFinancialYear" ||
                          col.field === "previousFinancialYear")
                          ? "none"
                          : "auto",
                    }}
                  >
                    {col.field === "parameter" ? (
                      row[col.field]
                    ) : col.type === "text" || col.type === "number" ? (
                      rowIndex === 0 &&
                      (col.field === "currentFinancialYear" ||
                        col.field === "previousFinancialYear") ? (
                        <TextField
                          size="small"
                          disabled={
                            disabled ||
                            (typeof row.parameter === "string" &&
                              row.parameter
                                .toLowerCase()
                                .includes("total volume of water withdrawal") &&
                              (col.field === "currentFinancialYear" ||
                                col.field === "previousFinancialYear"))
                          }
                          multiline
                          fullWidth
                          value={row[col.field] || ""}
                          onChange={(e) =>
                            onChange(rowIndex, col.field, e.target.value)
                          }
                          placeholder={
                            col.type === "number" ? "Enter Value" : "Enter Text"
                          }
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                            className: styles.textField,
                          }}
                          onKeyPress={(e) => {
                            if (col.type === "number" && !/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          className={styles.textFieldContainer}
                        />
                      ) : (
                        <TextField
                          size="small"
                          disabled={
                            disabled ||
                            (typeof row.parameter === "string" &&
                              row.parameter
                                .toLowerCase()
                                .includes("total volume of water withdrawal") &&
                              (col.field === "currentFinancialYear" ||
                                col.field === "previousFinancialYear"))
                          }
                          multiline
                          fullWidth
                          value={row[col.field] || ""}
                          onChange={(e) =>
                            onChange(rowIndex, col.field, e.target.value)
                          }
                          placeholder={
                            col.type === "number" ? "Enter Value" : "Enter Text"
                          }
                          variant="standard"
                          InputProps={{
                            disableUnderline: true,
                            className: styles.textField,
                          }}
                          onKeyPress={(e) => {
                            if (col.type === "number" && !/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          className={styles.textFieldContainer}
                        />
                      )
                    ) : (
                      row[col.field]
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const CustomTextField = ({
  value,
  placeholder,
  onChange,
  disabled,
  inputProps,
}) => (
  <TextField
    fullWidth
    value={value}
    size="small"
    disabled={disabled}
    placeholder={placeholder}
    variant="standard"
    InputProps={{
      disableUnderline: true,
      className: "textField",
    }}
    inputProps={inputProps}
    onChange={onChange}
  />
);

const ReusableRadioGroup = ({
  value,
  name,
  onChange,
  labels = { yes: "Yes", no: "No" },
  disabled,
}) => {
  return (
    <FormControl component="fieldset">
      <RadioGroup
        name={name}
        value={value ? "yes" : "no"}
        onChange={onChange}
        disabled={disabled}
        style={{
          display: "flex",
          flexDirection: "row",
          marginBottom: "10px",
          marginTop: "-10px",
          margin: "-10px 0px 10px 10px",
        }}
      >
        <FormControlLabel
          value="yes"
          control={<Radio disabled={disabled} />}
          label={labels.yes}
        />
        <FormControlLabel
          value="no"
          control={<Radio disabled={disabled} />}
          label={labels.no}
        />
      </RadioGroup>
    </FormControl>
  );
};

const LeadershipIndicator = ({
  onSave,
  hide,
  removeUpload = false,
  downloadMode = false,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);

  console.log(hide, "hide");
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [errorMessages, setErrorMessages] = useState({
    waterIndependantAssessment: [],
    externalAgency: [],
  });
  const [validationErrors, setValidationErrors] = useState({
    remark: false,
    webLink: false,
    zeroLiquidDischarge: false,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    waterWithDrawalConsumptionAndDischargDoc: [],
    scope3EmissionIntensityDoc: [],
    bioDiversityPreventionDoc: [],
    spcificIntiativesorUsedInnovativeDoc: [],
    busineessDisasterPlanDoc: [],
    disCloseDoc: [],
    valueChainDoc: [],
    greenCreditsDoc: [],
    zeroLiquidDischargeDoc: [],
    greenHouseGasBooleanEmissionsDoc: [],
    waterWithDrawalConsumptionAndDischarg: [
      {
        facilityName: "",
        nameOfArea: "",
        operation: "",
        waterWithdrawal: {
          surfaceWater: { currentFinancialYear: "", previousFinancialYear: "" },
          groundWater: { currentFinancialYear: "", previousFinancialYear: "" },
          thirdPartyWater: {
            currentFinancialYear: "",
            previousFinancialYear: "",
          },
          seaWater: { currentFinancialYear: "", previousFinancialYear: "" },
          other: { currentFinancialYear: "", previousFinancialYear: "" },
          total: { currentFinancialYear: "", previousFinancialYear: "" },
          totalWaterConsumption: {
            currentFinancialYear: "",
            previousFinancialYear: "",
          },
          waterIntensityPerRupee: {
            currentFinancialYear: "",
            previousFinancialYear: "",
          },
          waterIntensity: {
            currentFinancialYear: "",
            previousFinancialYear: "",
          },
        },

        waterDischargeCurrent: {
          toSurfaceWater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toGroundwater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toProducedWater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toThirdParties: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          others: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          total: "",
        },
        waterDischargePrevious: {
          toSurfaceWater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toGroundwater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toProducedWater: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          toThirdParties: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          others: {
            dischargeWithoutTreatment: "",
            treatmentLevel: "",
            dischargeAfterTreatment: "",
            unit: "KL",
          },
          total: "",
        },
      },
    ],

    waterIndependantAssessment: {
      action: true,
      name: [""],
    },
    // 2
    scope3EmissionIntensity: {
      totalScope3Emission: {
        currentFinancialYear: "",
        previousFinancialYear: "",
      },
      totalScope3EmissionPerRupeeturnOver: {
        currentFinancialYear: "",
        previousFinancialYear: "",
      },
      emissionIntensity: {
        currentFinancialYear: "",
        previousFinancialYear: "",
      },
    },

    externalAgency: {
      action: true,
      name: [""],
    },

    // 3
    bioDiversityPrevention: "",
    // 4
    spcificIntiativesorUsedInnovative: [
      {
        intiativeundertaken: "",
        detail: "",
        webLink: "",
        outCome: "",
      },
    ],
    // 5
    busineessDisasterPlan: {
      action: true,
      remark: "",
      webLink: "",
    },
    // 6
    disCloseAdverseImpactEnvironment: "",
    // 7
    valueChainPartnerAssessment: "",
    // 8
    greenCreditsByEntityCount: "",
    greenCreditsByEntityRemark: "",
    greenCreditsByValueChainPartnerCount: "",
    greenCreditsByValueChainPartnerRemark: "",
    // 9
    zeroLiquidDischarge: {
      action: true,
      remark: "",
    },
  });

  const [facilities, setFacilities] = useState([]);
  const [fieldToRemove, setFieldToRemove] = React.useState({
    tableField: null,
    index: null,
  });
  const [openDialog, setOpenDialog] = React.useState(false);

  const fetchFacilityList = async () => {
    try {
      const res = await get(`/dashboard/scope3/purchasegoods/facilitylist`);
      setFacilities(res?.data?.data.map((item) => item.facilityName));
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchFacilityList();
  }, []);

  const type = "SectionC";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `/brsr/get?subType=principle6&type=${type}&id=${id}`,
        );
        if (
          response?.data?.data?.year
            ? response?.data?.data?.year < currentYear - 1
            : false || !brsrReview
        )
          setDisabled(true);

        const defaultFacility = {
          facilityName: "",
          nameOfArea: "",
          operation: "",
          waterWithdrawal: {
            surfaceWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            groundWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            thirdPartyWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            seaWater: { currentFinancialYear: "", previousFinancialYear: "" },
            other: { currentFinancialYear: "", previousFinancialYear: "" },
            total: { currentFinancialYear: "", previousFinancialYear: "" },
            totalWaterConsumption: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            waterIntensityPerRupee: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            waterIntensity: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
          },
          waterDischargeCurrent: {
            toSurfaceWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toGroundwater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toProducedWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toThirdParties: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            others: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            total: "",
          },
          waterDischargePrevious: {
            toSurfaceWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toGroundwater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toProducedWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toThirdParties: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            others: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            total: "",
          },
        };

        if (
          response &&
          response.data &&
          response.data.data.BRSRSectionC &&
          response.data.data.BRSRSectionC.principle6.leadershipIndicator
        ) {
          const leadershipIndicator =
            response.data.data.BRSRSectionC.principle6.leadershipIndicator;

          // Update formData with the fetched data
          setFormData((prevFormData) => ({
            ...prevFormData,
            waterWithDrawalConsumptionAndDischargDoc:
              leadershipIndicator?.waterWithDrawalConsumptionAndDischargDoc ??
              [],
            scope3EmissionIntensityDoc:
              leadershipIndicator?.scope3EmissionIntensityDoc ?? [],
            bioDiversityPreventionDoc:
              leadershipIndicator?.bioDiversityPreventionDoc ?? [],
            spcificIntiativesorUsedInnovativeDoc:
              leadershipIndicator?.spcificIntiativesorUsedInnovativeDoc ?? [],
            busineessDisasterPlanDoc:
              leadershipIndicator?.busineessDisasterPlanDoc || [],
            disCloseDoc: leadershipIndicator?.disCloseDoc || [],
            valueChainDoc: leadershipIndicator?.valueChainDoc || [],
            greenCreditsDoc: leadershipIndicator?.greenCreditsDoc || [],
            waterWithDrawalConsumptionAndDischarg:
              // leadershipIndicator.waterWithDrawalConsumptionAndDischarg.map(
              leadershipIndicator.waterWithDrawalConsumptionAndDischarg
                ?.length > 0
                ? leadershipIndicator.waterWithDrawalConsumptionAndDischarg.map(
                    (facility) => ({
                      facilityName: facility.facilityName ?? "",
                      nameOfArea: facility.nameOfArea ?? "",
                      operation: facility.operation ?? "",
                      waterWithdrawal: {
                        surfaceWater: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.surfaceWater
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.surfaceWater
                              ?.previousFinancialYear ?? "",
                        },
                        groundWater: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.groundWater
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.groundWater
                              ?.previousFinancialYear ?? "",
                        },
                        thirdPartyWater: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.thirdPartyWater
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.thirdPartyWater
                              ?.previousFinancialYear ?? "",
                        },
                        seaWater: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.seaWater
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.seaWater
                              ?.previousFinancialYear ?? "",
                        },
                        other: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.other
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.other
                              ?.previousFinancialYear ?? "",
                        },
                        total: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.total
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.total
                              ?.previousFinancialYear ?? "",
                        },
                        totalWaterConsumption: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.totalWaterConsumption
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.totalWaterConsumption
                              ?.previousFinancialYear ?? "",
                        },
                        waterIntensityPerRupee: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.waterIntensityPerRupee
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.waterIntensityPerRupee
                              ?.previousFinancialYear ?? "",
                        },
                        waterIntensity: {
                          currentFinancialYear:
                            facility?.waterWithdrawal?.waterIntensity
                              ?.currentFinancialYear ?? "",
                          previousFinancialYear:
                            facility?.waterWithdrawal?.waterIntensity
                              ?.previousFinancialYear ?? "",
                        },
                      },
                      waterDischargeCurrent: {
                        toSurfaceWater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargeCurrent?.toSurfaceWater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargeCurrent?.toSurfaceWater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargeCurrent?.toSurfaceWater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toGroundwater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargeCurrent?.toGroundwater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargeCurrent?.toGroundwater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargeCurrent?.toGroundwater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toProducedWater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargeCurrent?.toProducedWater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargeCurrent?.toProducedWater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargeCurrent?.toProducedWater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toThirdParties: {
                          dischargeWithoutTreatment:
                            facility.waterDischargeCurrent?.toThirdParties
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargeCurrent?.toThirdParties
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargeCurrent?.toThirdParties
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        others: {
                          dischargeWithoutTreatment:
                            facility.waterDischargeCurrent?.others
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargeCurrent?.others
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargeCurrent?.others
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        total: facility.waterDischargeCurrent?.total ?? "",
                      },
                      waterDischargePrevious: {
                        toSurfaceWater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargePrevious?.toSurfaceWater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargePrevious?.toSurfaceWater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargePrevious?.toSurfaceWater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toGroundwater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargePrevious?.toGroundwater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargePrevious?.toGroundwater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargePrevious?.toGroundwater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toProducedWater: {
                          dischargeWithoutTreatment:
                            facility.waterDischargePrevious?.toProducedWater
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargePrevious?.toProducedWater
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargePrevious?.toProducedWater
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        toThirdParties: {
                          dischargeWithoutTreatment:
                            facility.waterDischargePrevious?.toThirdParties
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargePrevious?.toThirdParties
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargePrevious?.toThirdParties
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        others: {
                          dischargeWithoutTreatment:
                            facility.waterDischargePrevious?.others
                              ?.dischargeWithoutTreatment ?? "",
                          treatmentLevel:
                            facility.waterDischargePrevious?.others
                              ?.treatmentLevel ?? "",
                          dischargeAfterTreatment:
                            facility.waterDischargePrevious?.others
                              ?.dischargeAfterTreatment ?? "",
                          unit: "KL",
                        },
                        total: facility.waterDischargePrevious?.total ?? "",
                      },
                    }),
                  )
                : [defaultFacility],

            waterIndependantAssessment: (() => {
              const assessment = leadershipIndicator.waterIndependantAssessment;
              if (assessment) {
                return {
                  ...assessment,
                  name:
                    assessment.name &&
                    Array.isArray(assessment.name) &&
                    assessment.name.length > 0
                      ? assessment.name
                      : [""],
                };
              }
              return {
                action: true,
                name: [""],
              };
            })(),

            // scope3EmissionIntensity:
            //   leadershipIndicator.scope3EmissionIntensity,
            scope3EmissionIntensity: {
              totalScope3Emission: {
                currentFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity
                    ?.totalScope3Emission?.currentFinancialYear ?? "",
                previousFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity
                    ?.totalScope3Emission?.previousFinancialYear ?? "",
              },
              totalScope3EmissionPerRupeeturnOver: {
                currentFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity
                    ?.totalScope3EmissionPerRupeeturnOver
                    ?.currentFinancialYear ?? "",
                previousFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity
                    ?.totalScope3EmissionPerRupeeturnOver
                    ?.previousFinancialYear ?? "",
              },
              emissionIntensity: {
                currentFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity?.emissionIntensity
                    ?.currentFinancialYear ?? "",
                previousFinancialYear:
                  leadershipIndicator.scope3EmissionIntensity?.emissionIntensity
                    ?.previousFinancialYear ?? "",
              },
              externalAgency:
                leadershipIndicator.scope3EmissionIntensity?.externalAgency ??
                "",
            },
            externalAgency: (() => {
              const agency =
                leadershipIndicator.scope3EmissionIntensity?.externalAgency;
              if (agency) {
                return {
                  ...agency,
                  name:
                    agency.name &&
                    Array.isArray(agency.name) &&
                    agency.name.length > 0
                      ? agency.name
                      : [""],
                };
              }
              return {
                action: true,
                name: [""],
              };
            })(),
            bioDiversityPrevention: leadershipIndicator.bioDiversityPrevention,
            // spcificIntiativesorUsedInnovative:
            //   leadershipIndicator.spcificIntiativesorUsedInnovative,
            spcificIntiativesorUsedInnovative:
              leadershipIndicator.spcificIntiativesorUsedInnovative?.length > 0
                ? leadershipIndicator.spcificIntiativesorUsedInnovative
                : [
                    {
                      intiativeundertaken: "",
                      detail: "",
                      webLink: "",
                      outCome: "",
                    },
                  ],
            busineessDisasterPlan: leadershipIndicator.busineessDisasterPlan,
            disCloseAdverseImpactEnvironment:
              leadershipIndicator.disCloseAdverseImpactEnvironment,
            valueChainPartnerAssessment:
              leadershipIndicator.valueChainPartnerAssessment,
            greenCreditsByEntityCount:
              leadershipIndicator.greenCreditsByEntityCount ?? "",
            greenCreditsByEntityRemark:
              leadershipIndicator.greenCreditsByEntityRemark ?? "",
            greenCreditsByValueChainPartnerCount:
              leadershipIndicator.greenCreditsByValueChainPartnerCount ?? "",
            greenCreditsByValueChainPartnerRemark:
              leadershipIndicator.greenCreditsByValueChainPartnerRemark || "",
          }));
        } else {
          console.error("Essential Indicators data is not available.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [type]);

  const confirmRemoveRow = () => {
    if (fieldToRemove.tableField && fieldToRemove.index !== null) {
      setFormData((prev) => {
        const updatedTable = [...prev[fieldToRemove.tableField]];
        updatedTable.splice(fieldToRemove.index, 1);
        return {
          ...prev,
          [fieldToRemove.tableField]: updatedTable.map((row, index) => ({
            ...row,
            serialNumber: index + 1,
          })),
        };
      });
      setOpenDialog(false);
      setFieldToRemove({ tableField: null, index: null });
    }
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
    setFieldToRemove({ tableField: null, index: null });
  };

  const checkRowHasData = (row, fieldsToCheck) => {
    return fieldsToCheck.some((field) => row[field]?.trim() !== "");
  };

  // Modified delete handler for tables
  const handleDeleteRow = (tableField, index, fieldsToCheck) => {
    const currentRow = formData[tableField][index];
    if (!currentRow) return;
    if (checkRowHasData(currentRow, fieldsToCheck)) {
      // Show confirmation dialog if data exists
      setFieldToRemove({ tableField, index });
      setOpenDialog(true);
    } else {
      // Immediately delete empty row
      setFormData((prev) => {
        const updatedTable = [...prev[tableField]];
        updatedTable.splice(index, 1);
        return {
          ...prev,
          [tableField]: updatedTable.map((row, index) => ({
            ...row,
            serialNumber: index + 1,
          })),
        };
      });
    }
  };

  const getAvailableFacilities = (facilityIndex) => {
    const selectedFacilities = formData.waterWithDrawalConsumptionAndDischarg
      .map((facility, index) =>
        index !== facilityIndex ? facility.facilityName : null,
      )
      .filter(Boolean); // Remove null values

    return facilities.map((facility) => ({
      value: facility,
      disabled: selectedFacilities.includes(facility), // Mark as disabled if already selected
    }));
  };

  const handleInputChange = (facilityIndex, section, key, field, value) => {
    const updatedFormData = [...formData.waterWithDrawalConsumptionAndDischarg];
    const waterWithdrawal = updatedFormData[facilityIndex][section];

    if (!waterWithdrawal[key]) {
      waterWithdrawal[key] = {
        currentFinancialYear: "",
        previousFinancialYear: "",
        currentUnit: "",
        previousUnit: "",
      };
    }

    if (
      field === "currentFinancialYear" ||
      field === "previousFinancialYear" ||
      field === "currentUnit" ||
      field === "previousUnit"
    ) {
      waterWithdrawal[key][field] = value;
    }

    const waterSources = [
      "surfaceWater",
      "groundWater",
      "thirdPartyWater",
      "seaWater",
      "other",
    ];

    const total = (type) =>
      waterSources.reduce(
        (sum, source) => sum + parseFloat(waterWithdrawal[source]?.[type] || 0),
        0,
      );

    waterWithdrawal.total.currentFinancialYear = total(
      "currentFinancialYear",
    ).toString();
    waterWithdrawal.total.previousFinancialYear = total(
      "previousFinancialYear",
    ).toString();

    setFormData((prevData) => ({
      ...prevData,
      waterWithDrawalConsumptionAndDischarg: updatedFormData,
    }));
  };

  const handleChangeWater = (facilityIndex, section, value) => {
    const updatedFormData = [...formData.waterWithDrawalConsumptionAndDischarg];

    updatedFormData[facilityIndex][section] = value;

    setFormData((prevData) => ({
      ...prevData,
      waterWithDrawalConsumptionAndDischarg: updatedFormData,
    }));
  };

  const handleInputChange1 = (section, index, field, value) => {
    setFormData((prevFormData) => {
      const updatedSection = [...prevFormData[section]];
      updatedSection[index] = {
        ...updatedSection[index],
        [field]: value,
      };
      return {
        ...prevFormData,
        [section]: updatedSection,
      };
    });
  };

  const handleInputChangeEmission = (path, value) => {
    const keys = path.split(".");
    const updatedFormData = { ...formData };
    let current = updatedFormData;
    keys.slice(0, -1).forEach((key) => {
      current = current[key];
    });
    current[keys[keys.length - 1]] = value;
    setFormData(updatedFormData);
  };

  const addNewInitiative = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      spcificIntiativesorUsedInnovative: [
        ...prevFormData.spcificIntiativesorUsedInnovative,
        { intiativeundertaken: "", detail: "", webLink: "", outCome: "" },
      ],
    }));
  };

  const dataKeys = ["intiativeundertaken", "detail", "webLink", "outCome"];

  const dataKeysEmission = [
    {
      key: "totalScope3Emission",
      label:
        "Total Scope 3 emissions (Break-up of the GHG into CO2, CH4, N2O, HFCs, PFCs, SF6, NF3, if available)",
    },
    {
      key: "totalScope3EmissionPerRupeeturnOver",
      label: "Total Scope 3 emissions per rupee of turnover",
    },
    {
      key: "emissionIntensity",
      label:
        "Total Scope 3 emission intensity (optional) – the relevant metric may be selected by the entity",
    },
  ];

  const handleAddField = (fieldPath) => {
    setFormData((prev) => {
      const keys = fieldPath.split(".");
      const updatedData = { ...prev };

      let target = keys.reduce((acc, key, index) => {
        if (index === keys.length - 1) {
          acc[key] = Array.isArray(acc[key]) ? [...acc[key], ""] : [""]; // Add an empty string
        } else {
          acc[key] = acc[key] || {};
        }
        return acc[key];
      }, updatedData);

      return updatedData;
    });
  };

  const handleRemoveField = (fieldPath, index) => {
    setFormData((prev) => {
      const keys = fieldPath.split(".");
      const updatedData = { ...prev };

      let target = keys.reduce((acc, key, i) => {
        if (i === keys.length - 1) {
          if (Array.isArray(acc[key])) {
            acc[key] = acc[key].filter((_, i) => i !== index); // Remove the specific index
          }
        } else {
          acc[key] = acc[key] || {};
        }
        return acc[key];
      }, updatedData);

      return updatedData;
    });
  };

  const handleRadioChange = (fieldPath, value) => {
    const keys = fieldPath.split(".");
    const updatedData = { ...formData };
    const isYes = value === "yes" || value === true;

    keys.reduce((acc, key, index) => {
      if (index === keys.length - 1) {
        acc[key] = isYes;
      } else {
        acc[key] = acc[key] || {};
      }
      return acc[key];
    }, updatedData);

    // Initialize name array when "yes" is selected for fields that have name arrays
    if (isYes) {
      switch (fieldPath) {
        case "waterIndependantAssessment.action":
          if (
            !updatedData.waterIndependantAssessment.name ||
            updatedData.waterIndependantAssessment.name.length === 0
          ) {
            updatedData.waterIndependantAssessment.name = [""];
          }
          break;

        case "externalAgency.action":
          if (
            !updatedData.externalAgency.name ||
            updatedData.externalAgency.name.length === 0
          ) {
            updatedData.externalAgency.name = [""];
          }
          break;

        default:
          break;
      }
    } else {
      // Clear related fields when "no" is selected
      switch (fieldPath) {
        case "waterIndependantAssessment.action":
          updatedData.waterIndependantAssessment.name = [""];
          setErrorMessages((prev) => ({
            ...prev,
            waterIndependantAssessment: [],
          }));
          break;

        case "externalAgency.action":
          updatedData.externalAgency.name = [""];
          setErrorMessages((prev) => ({
            ...prev,
            externalAgency: [],
          }));
          break;

        case "zeroLiquidDischarge.action":
          updatedData.zeroLiquidDischarge.remark = "";
          setValidationErrors((prev) => ({
            ...prev,
            zeroLiquidDischarge: false,
          }));
          break;

        default:
          break;
      }
    }

    setFormData(updatedData);
  };

  const handleTextFieldChange = (fieldPath, index, value) => {
    setFormData((prev) => {
      const keys = fieldPath.split(".");
      const updatedData = { ...prev };

      let target = keys.reduce((acc, key, i) => {
        if (i === keys.length - 1) {
          if (Array.isArray(acc[key])) {
            acc[key] = [...acc[key]];
            acc[key][index] = value;
          }
        } else {
          acc[key] = acc[key] || {};
        }
        return acc[key];
      }, updatedData);

      return updatedData;
    });

    // Clear error for this specific field
    setErrorMessages((prevErrors) => {
      const fieldKey = fieldPath.split(".")[0]; // Extract the field key (e.g., "waterDischargeExternalAgency")
      const updatedErrors = { ...prevErrors };
      updatedErrors[fieldKey] = updatedErrors[fieldKey] || []; // Ensure the field is initialized as an array
      updatedErrors[fieldKey][index] =
        value.trim() === "" ? "This field is required" : "";
      return updatedErrors;
    });
  };

  const calculateTotalDischarge = (type) => {
    return parameters.reduce((total, parameter) => {
      const dischargeData =
        formData.waterWithDrawalConsumptionAndDischarg[0]?.[type]?.[
          parameter
        ] || {};
      const withoutTreatment =
        parseFloat(dischargeData.dischargeWithoutTreatment) || 0;
      const withTreatment =
        parseFloat(dischargeData.dischargeAfterTreatment) || 0;
      return total + withoutTreatment + withTreatment;
    }, 0);
  };

  const handleTextFieldChange1 = (path, value) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData };
      const keys = path.split(".");
      let temp = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!temp[keys[i]]) temp[keys[i]] = i === 0 ? [] : {}; // Ensure nested array/object exists
        temp = temp[keys[i]];
      }

      temp[keys[keys.length - 1]] = value;
      return { ...updatedData };
    });
  };

  const handleTextFieldChange2 = (fieldPath, value) => {
    const keys = fieldPath.split(".");
    const updatedData = { ...formData };

    keys.reduce((acc, key, index) => {
      if (index === keys.length - 1) {
        acc[key] = value;
      } else {
        acc[key] = acc[key] || {};
      }
      return acc[key];
    }, updatedData);

    setFormData(updatedData);
    // Clear validation error for the field
    if (keys[1] === "remark") {
      setValidationErrors((prevErrors) => ({
        ...prevErrors,
        [keys[0]]: false,
      }));
    }
  };

  const [modalupload, setModalUpload] = useState({
    waterWithDrawalConsumptionAndDischargDoc: false,
    scope3EmissionIntensityDoc: false,
    bioDiversityPreventionDoc: false,
    spcificIntiativesorUsedInnovativeDoc: false,
    busineessDisasterPlanDoc: false,
    disCloseDoc: false,
    valueChainDoc: false,
    greenCreditsDoc: false,
    zeroLiquidDischargeDoc: false,
  });

  const [errors, setErrors] = useState({});

  const addNewFacility = () => {
    setFormData((prevData) => ({
      ...prevData,
      waterWithDrawalConsumptionAndDischarg: [
        ...prevData.waterWithDrawalConsumptionAndDischarg,
        {
          facilityName: "",
          nameOfArea: "",
          operation: "",
          waterWithdrawal: {
            surfaceWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            groundWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            thirdPartyWater: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            seaWater: { currentFinancialYear: "", previousFinancialYear: "" },
            other: { currentFinancialYear: "", previousFinancialYear: "" },
            total: { currentFinancialYear: "", previousFinancialYear: "" },
            totalWaterConsumption: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            waterIntensityPerRupee: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
            waterIntensity: {
              currentFinancialYear: "",
              previousFinancialYear: "",
            },
          },
          waterDischargeCurrent: {
            toSurfaceWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toGroundwater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toProducedWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toThirdParties: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            others: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            total: "",
          },
          waterDischargePrevious: {
            toSurfaceWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toGroundwater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toProducedWater: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            toThirdParties: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            others: {
              dischargeWithoutTreatment: "",
              treatmentLevel: "",
              dischargeAfterTreatment: "",
              unit: "KL",
            },
            total: "",
          },
        },
      ],
    }));
  };

  const deleteFacility = (index) => {
    setFormData((prevData) => {
      const updatedFacilities = [
        ...prevData.waterWithDrawalConsumptionAndDischarg,
      ];
      updatedFacilities.splice(index, 1); // Remove the facility at the specified index
      return {
        ...prevData,
        waterWithDrawalConsumptionAndDischarg: updatedFacilities,
      };
    });
  };

  const validateForm = () => {
    let isValid = true;
    const newErrorMessages = { ...errorMessages };

    if (formData?.waterIndependantAssessment?.action) {
      newErrorMessages.waterIndependantAssessment =
        formData?.waterIndependantAssessment?.name?.map((name) =>
          name.trim() === "" ? "This field is required" : "",
        );
      if (
        newErrorMessages.waterIndependantAssessment.some(
          (error) => error !== "",
        )
      ) {
        isValid = false;
      }
    }

    if (formData?.externalAgency?.action) {
      newErrorMessages.externalAgency = formData.externalAgency.name.map(
        (name) => (name.trim() === "" ? "This field is required" : ""),
      );
      if (newErrorMessages.externalAgency.some((error) => error !== "")) {
        isValid = false;
      }
    }

    setErrorMessages(newErrorMessages);
    return isValid;
  };

  const validateFields = () => {
    let isValid = true;
    const newValidationErrors = {
      remark: false,
      webLink: false,
      zeroLiquidDischarge: false,
    };

    const urlPattern =
      /^(https?:\/\/)?(www\.)?(([\p{L}0-9-]+\.)+[\p{L}]{2,}|(\d{1,3}\.){3}\d{1,3})(:\d{2,5})?(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/u;

    if (formData?.busineessDisasterPlan?.action) {
      if (formData.busineessDisasterPlan.remark === "") {
        newValidationErrors.remark = true;
        isValid = false;
      }
      if (formData.busineessDisasterPlan.webLink === "") {
        newValidationErrors.webLink = "This field is required";
        isValid = false;
      } else if (!urlPattern.test(formData.busineessDisasterPlan.webLink)) {
        newValidationErrors.webLink = "Enter a valid URL";
        isValid = false;
      }
    }

    // if (
    //   formData?.zeroLiquidDischarge?.action &&
    //   !formData.zeroLiquidDischarge.remark
    // ) {
    //   newValidationErrors.zeroLiquidDischarge = true;
    //   isValid = false;
    // }

    setValidationErrors(newValidationErrors);
    return isValid;
  };
  // ✅ Reusable validator only for spcificIntiativesorUsedInnovative.webLink
  const validateSpecificInitiativesUrls = () => {
    const initiatives = formData?.spcificIntiativesorUsedInnovative || [];

    // Collect invalid rows and set error for Table 4 footer instead of snackbar
    const asciiUrlPattern =
      /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\:\d{2,5})?(\/[^\s]*)?$/;
    const invalid = initiatives
      .map((it, i) => ({ i, val: String(it.webLink || "").trim() }))
      .filter((r) => r.val && !asciiUrlPattern.test(r.val));
    if (invalid.length > 0) {
      const rows = invalid.map((r) => r.i + 1).join(", ");
      setErrors((prev) => ({
        ...prev,
        spcificIntiativesorUsedInnovative: `Please enter a valid URL in Table 4 row(s): ${rows}.`,
      }));
      return false;
    }
    setErrors((prev) => ({ ...prev, spcificIntiativesorUsedInnovative: "" }));
    return true; // valid
  };

  const handleSubmit = async () => {
    if (!disabled) {
      setIsSubmitted(true);
      const isValidateForm = validateForm();
      const isValidateField = validateFields();

      if (!isValidateForm || !isValidateField) {
        return;
      }

      if (!validateSpecificInitiativesUrls()) return;

      let transformedData = {
        leadershipIndicator: {
          ...formData,
          waterWithDrawalConsumptionAndDischarg:
            formData.waterWithDrawalConsumptionAndDischarg.map((facility) => ({
              facilityName: facility.facilityName,
              nameOfArea: facility.nameOfArea,
              operation: facility.operation,
              waterWithdrawal: {
                surfaceWater: facility.waterWithdrawal.surfaceWater,
                groundWater: facility.waterWithdrawal.groundWater,
                thirdPartyWater: facility.waterWithdrawal.thirdPartyWater,
                seaWater: facility.waterWithdrawal.seaWater,
                other: facility.waterWithdrawal.other,
                total: facility.waterWithdrawal.total,
                totalWaterConsumption:
                  facility.waterWithdrawal.totalWaterConsumption,
                waterIntensityPerRupee:
                  facility.waterWithdrawal.waterIntensityPerRupee,
                waterIntensity: facility.waterWithdrawal.waterIntensity,
              },
              waterDischargeCurrent: {
                toSurfaceWater: facility.waterDischargeCurrent.toSurfaceWater,
                toGroundwater: facility.waterDischargeCurrent.toGroundwater,
                toProducedWater: facility.waterDischargeCurrent.toProducedWater,
                toThirdParties: facility.waterDischargeCurrent.toThirdParties,
                others: facility.waterDischargeCurrent.others,
                total: facility.waterDischargeCurrent.total,
              },
              waterDischargePrevious: {
                toSurfaceWater: facility.waterDischargePrevious.toSurfaceWater,
                toGroundwater: facility.waterDischargePrevious.toGroundwater,
                toProducedWater:
                  facility.waterDischargePrevious.toProducedWater,
                toThirdParties: facility.waterDischargePrevious.toThirdParties,
                others: facility.waterDischargePrevious.others,
                total: facility.waterDischargePrevious.total,
              },
            })),
          waterIndependantAssessment: formData.waterIndependantAssessment,
          scope3EmissionIntensity: {
            totalScope3Emission: {
              currentFinancialYear: Number(
                formData?.scope3EmissionIntensity?.totalScope3Emission
                  ?.currentFinancialYear,
              ),
              previousFinancialYear: Number(
                formData?.scope3EmissionIntensity?.totalScope3Emission
                  ?.previousFinancialYear,
              ),
            },
            totalScope3EmissionPerRupeeturnOver: {
              currentFinancialYear: Number(
                formData?.scope3EmissionIntensity
                  ?.totalScope3EmissionPerRupeeturnOver?.currentFinancialYear,
              ),
              previousFinancialYear: Number(
                formData?.scope3EmissionIntensity
                  ?.totalScope3EmissionPerRupeeturnOver?.previousFinancialYear,
              ),
            },
            emissionIntensity: {
              currentFinancialYear: Number(
                formData?.scope3EmissionIntensity?.emissionIntensity
                  ?.currentFinancialYear,
              ),
              previousFinancialYear: Number(
                formData?.scope3EmissionIntensity?.emissionIntensity
                  ?.previousFinancialYear,
              ),
            },
            externalAgency: formData?.externalAgency,
          },
          bioDiversityPrevention: formData?.bioDiversityPrevention,
          //4
          spcificIntiativesorUsedInnovative:
            formData.spcificIntiativesorUsedInnovative.map((item) => ({
              intiativeundertaken: item.intiativeundertaken,
              detail: item.detail,
              webLink: item.webLink,
              outCome: item.outCome,
            })),
          //5
          busineessDisasterPlan: {
            action: formData?.busineessDisasterPlan?.action,
            remark: formData?.busineessDisasterPlan?.remark,
            webLink: formData?.busineessDisasterPlan?.webLink,
          },
          disCloseAdverseImpactEnvironment:
            formData.disCloseAdverseImpactEnvironment,
          valueChainPartnerAssessment: formData.valueChainPartnerAssessment,
          zeroLiquidDischarge: formData.zeroLiquidDischarge,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle6",
      };

      try {
        const response = await put(`/brsr/update?id=${id}`, transformedData);
        setsnackOpen({
          open: true,
          message: "Data saved successfully!",
          severity: "success",
        });
        navigate(`/brsr/section-c/principle7/${id}`);
        if (onSave) onSave(response.data);
      } catch (error) {
        console.error(error);
        setsnackOpen({
          open: true,
          message: "Failed to save data. Please try again.",
          severity: "error",
        });
      }
    }
  };

  const tablestyles = {
    headerCell: {
      color: "#fff",
      fontWeight: "bold",
      textAlign: "center",
      borderRight: "1px solid #fff",
    },
    bodyCell: {
      padding: "6px 16px",
      border: "1px solid rgba(224, 224, 224, 1)",
    },
    textField: {
      size: "small",
      fullWidth: true,
      variant: "standard",
      InputProps: { disableUnderline: true, className: "textField" },
    },
  };

  const parameters = [
    "toSurfaceWater",
    "toGroundwater",
    "toProducedWater",
    "toThirdParties",
    "others",
  ];

  const parameterDisplayMap = {
    toSurfaceWater: "To Surface Water",
    toGroundwater: "To Groundwater",
    toProducedWater: "To Seawater",
    toThirdParties: "Sent to Third Parties",
    others: "Others",
  };

  return (
    <>
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>
      <Box>
        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            1. Water withdrawal, consumption and discharge in areas of water
            stress (in kilolitres): <br /> For each facility / plant located in
            areas of water stress, provide the following information:
          </p>

          {formData.waterWithDrawalConsumptionAndDischarg.map(
            (facility, facilityIndex) => (
              <Box key={facilityIndex} sx={{ mb: 4, marginLeft: "1rem" }}>
                <p
                  className={style.question_subtitle}
                  style={{ marginBottom: "-0.1rem" }}
                >
                  Select Facility
                </p>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Select
                    fullWidth
                    disabled={disabled}
                    sx={{ margin: "0.2rem 0rem 1rem 0rem", width: "48.2%" }}
                    size="small"
                    value={
                      formData.waterWithDrawalConsumptionAndDischarg[
                        facilityIndex
                      ].facilityName
                    }
                    onChange={(e) =>
                      handleChangeWater(
                        facilityIndex,
                        "facilityName",
                        e.target.value,
                      )
                    }
                    className={styles["dynamic-select-input"]}
                    displayEmpty
                  >
                    <MenuItem value=""> Select Facility</MenuItem>
                    {getAvailableFacilities(facilityIndex).map((facility) => (
                      <MenuItem
                        key={facility.value}
                        value={facility.value}
                        disabled={facility.disabled} // Disable if already selected
                      >
                        {facility.value}
                      </MenuItem>
                    ))}
                  </Select>
                  {formData.waterWithDrawalConsumptionAndDischarg.length >
                    1 && (
                    <IconButton
                      onClick={() => deleteFacility(facilityIndex)}
                      sx={{
                        color: "red",
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  )}
                </Box>

                <Box style={{ display: "flex", gap: "2rem" }}>
                  <div style={{ width: "50%" }}>
                    <p
                      className={style.question_subtitle}
                      style={{ marginBottom: "-0.1rem" }}
                    >
                      (i) Name of area
                    </p>
                    <TextField
                      size="small"
                      disabled={disabled}
                      placeholder="Enter Text"
                      // label="Enter here"
                      value={
                        formData.waterWithDrawalConsumptionAndDischarg[
                          facilityIndex
                        ].nameOfArea
                      }
                      onChange={(e) =>
                        handleChangeWater(
                          facilityIndex,
                          "nameOfArea",
                          e.target.value,
                        )
                      }
                      fullWidth
                      sx={{ mb: 2, marginTop: "0.2rem" }}
                    />
                  </div>
                  <div style={{ width: "50%" }}>
                    <p
                      className={style.question_subtitle}
                      style={{ marginBottom: "-0.1rem" }}
                    >
                      (ii) Nature of Operation
                    </p>
                    <TextField
                      placeholder="Enter Text"
                      disabled={disabled}
                      value={
                        formData.waterWithDrawalConsumptionAndDischarg[
                          facilityIndex
                        ].operation
                      }
                      size="small"
                      onChange={(e) =>
                        handleChangeWater(
                          facilityIndex,
                          "operation",
                          e.target.value,
                        )
                      }
                      fullWidth
                      sx={{ mb: 2, marginTop: "0.2rem" }}
                    />
                  </div>
                </Box>
                {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
                <p
                  className={style.question_subtitle}
                  style={{ marginBottom: "-0.1rem" }}
                >
                  (iii) Water withdrawal, consumption and discharge by Source
                </p>
                <div
                  style={{
                    borderRadius: "10px 10px 0 0px",
                    backgroundColor: "#1C486B",
                    color: "white",
                    padding: "0.5rem 1rem",
                    borderBottom: "1px solid #ccc",
                    marginTop: "1.2rem",
                  }}
                >
                  Water withdrawal by source (in kiloliters)
                </div>
                <ReusableTable
                  disabled={disabled}
                  rows={Object.keys(facility.waterWithdrawal).map((key) => ({
                    parameter:
                      key === "surfaceWater"
                        ? "(i) Surface water"
                        : key === "groundWater"
                          ? "(ii) Ground water"
                          : key === "thirdPartyWater"
                            ? "(iii) Third party water"
                            : key === "seaWater"
                              ? "(iv) Seawater / desalinated water"
                              : key === "other"
                                ? "(v) Others"
                                : key === "total"
                                  ? "Total volume of water withdrawal"
                                  : key === "totalWaterConsumption"
                                    ? "Total volume of water consumption (in kiloliters)"
                                    : key === "waterIntensityPerRupee"
                                      ? "Water intensity per rupee of turnover (Water consumed / turnover)"
                                      : key === "waterIntensity"
                                        ? "Water intensity (optional) - the relevant metric may be selected by the entity"
                                        : "",
                    currentFinancialYear:
                      facility?.waterWithdrawal[key]?.currentFinancialYear ||
                      "",
                    previousFinancialYear:
                      facility?.waterWithdrawal[key]?.previousFinancialYear ||
                      "",
                    currentUnit:
                      facility?.waterWithdrawal[key]?.currentUnit || "",
                    previousUnit:
                      facility?.waterWithdrawal[key]?.previousUnit || "",
                  }))}
                  columns={[
                    {
                      label: "Parameter",
                      field: "parameter",
                      type: "text",
                      width: "40%",
                    },
                    {
                      label: "Current Financial Year",
                      field: "currentFinancialYear",
                      type: "number",
                      width: "25%",
                    },
                    {
                      label: "Previous Financial Year",
                      field: "previousFinancialYear",
                      type: "number",
                      width: "25%",
                    },
                  ]}
                  onChange={(rowIndex, field, value) =>
                    handleInputChange(
                      facilityIndex,
                      "waterWithdrawal",
                      Object.keys(facility.waterWithdrawal)[rowIndex],
                      field,
                      value,
                    )
                  }
                />
                {/* Another table */}
                <TableContainer
                  component={Paper}
                  sx={{
                    // width: "98%",
                    marginTop: "-0.7rem",
                    mb: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <Table>
                    <TableHead>
                      <TableRow
                        sx={{ backgroundColor: "#1E4976", color: "#fff" }}
                      >
                        <TableCell
                          sx={{ ...tablestyles.headerCell, textAlign: "left" }}
                          colSpan={8}
                        >
                          Water Discharged by source (in kilolitres)
                        </TableCell>
                      </TableRow>
                      <TableRow
                        sx={{ backgroundColor: "#1E4976", color: "#fff" }}
                      >
                        <TableCell
                          sx={{ ...tablestyles.headerCell }}
                          colSpan={2}
                          rowSpan={2}
                        >
                          Parameter
                        </TableCell>
                        <TableCell
                          sx={{ ...tablestyles.headerCell }}
                          colSpan={2}
                        >
                          Current Financial Year
                        </TableCell>
                        <TableCell
                          sx={{ ...tablestyles.headerCell }}
                          colSpan={2}
                        >
                          Previous Financial Year
                        </TableCell>
                      </TableRow>
                      <TableRow sx={{ backgroundColor: "#1E4976" }}>
                        <TableCell sx={{ ...tablestyles.headerCell }}>
                          Water Discharge (in KL)
                        </TableCell>
                        <TableCell sx={{ ...tablestyles.headerCell }}>
                          Specify level of treatment
                        </TableCell>
                        <TableCell sx={{ ...tablestyles.headerCell }}>
                          Water Discharged (in KL)
                        </TableCell>
                        <TableCell sx={{ ...tablestyles.headerCell }}>
                          Specify level of treatment
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {parameters.map((parameter, index) => (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell
                              sx={{ ...tablestyles.bodyCell }}
                              rowSpan={2}
                            >
                              {parameterDisplayMap[parameter]}
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              Not treated
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Enter Number"
                                type="number"
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  min: 0,
                                  step: "any",
                                }}
                                // value={
                                //   formData
                                //     .waterWithDrawalConsumptionAndDischarg[0]
                                //     ?.waterDischargeCurrent[parameter]
                                //     ?.dischargeWithoutTreatment || ""
                                // }
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargeCurrent[parameter]
                                    ?.dischargeWithoutTreatment || ""
                                }
                                multiline
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   if (/^\d*\.?\d*$/.test(value)) {
                                //     handleTextFieldChange1(
                                //       `waterWithDrawalConsumptionAndDischarg.0.waterDischargeCurrent.${parameter}.dischargeWithoutTreatment`,
                                //       e.target.value
                                //     );
                                //   }
                                // }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargeCurrent.${parameter}.dischargeWithoutTreatment`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tablestyles.bodyCell,
                                backgroundColor: "#EFEFEF",
                              }}
                            >
                              -
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Enter Number"
                                type="number"
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  min: 0,
                                  step: "any",
                                }}
                                // value={
                                //   formData
                                //     .waterWithDrawalConsumptionAndDischarg[0]
                                //     ?.waterDischargePrevious[parameter]
                                //     ?.dischargeWithoutTreatment || ""
                                // }
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargePrevious[parameter]
                                    ?.dischargeWithoutTreatment || ""
                                }
                                multiline
                                // onChange={(e) => {
                                //   const value = e.target.value;
                                //   if (/^\d*\.?\d*$/.test(value)) {
                                //     handleTextFieldChange1(
                                //       `waterWithDrawalConsumptionAndDischarg.0.waterDischargePrevious.${parameter}.dischargeWithoutTreatment`,
                                //       e.target.value
                                //     );
                                //   }
                                // }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargePrevious.${parameter}.dischargeWithoutTreatment`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell
                              sx={{
                                ...tablestyles.bodyCell,
                                backgroundColor: "#EFEFEF",
                              }}
                            >
                              -
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              With treatment
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Enter Number"
                                type="number"
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  min: 0,
                                  step: "any",
                                }}
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargeCurrent[parameter]
                                    ?.dischargeAfterTreatment || ""
                                }
                                multiline
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargeCurrent.${parameter}.dischargeAfterTreatment`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Type Here"
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargeCurrent[parameter]
                                    ?.treatmentLevel || ""
                                }
                                multiline
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargeCurrent.${parameter}.treatmentLevel`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Enter Number"
                                type="number"
                                inputProps={{
                                  inputMode: "numeric",
                                  pattern: "[0-9]*",
                                  min: 0,
                                  step: "any",
                                }}
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargePrevious[parameter]
                                    ?.dischargeAfterTreatment || ""
                                }
                                multiline
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargePrevious.${parameter}.dischargeAfterTreatment`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ ...tablestyles.bodyCell }}>
                              <TextField
                                disabled={disabled}
                                {...tablestyles.textField}
                                placeholder="Type Here"
                                value={
                                  formData
                                    .waterWithDrawalConsumptionAndDischarg[
                                    facilityIndex
                                  ]?.waterDischargePrevious[parameter]
                                    ?.treatmentLevel || ""
                                }
                                multiline
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*\.?\d*$/.test(value)) {
                                    handleTextFieldChange1(
                                      `waterWithDrawalConsumptionAndDischarg.${facilityIndex}.waterDischargePrevious.${parameter}.treatmentLevel`,
                                      e.target.value,
                                    );
                                  }
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      ))}
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          sx={{ ...tablestyles.bodyCell, fontWeight: 600 }}
                        >
                          Total water discharged (in kilolitres)
                        </TableCell>
                        <TableCell
                          sx={{
                            ...tablestyles.bodyCell,
                            backgroundColor: "#EFEFEF",
                            color: "#a3a3a3",
                          }}
                        >
                          {calculateTotalDischarge("waterDischargeCurrent") ??
                            "Total"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...tablestyles.bodyCell,
                            backgroundColor: "#EFEFEF",
                          }}
                        >
                          -
                        </TableCell>
                        <TableCell
                          sx={{
                            ...tablestyles.bodyCell,
                            backgroundColor: "#EFEFEF",
                            color: "#a3a3a3",
                          }}
                        >
                          {calculateTotalDischarge("waterDischargePrevious") ??
                            "Total"}
                        </TableCell>
                        <TableCell
                          sx={{
                            ...tablestyles.bodyCell,
                            backgroundColor: "#EFEFEF",
                          }}
                        >
                          -
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            ),
          )}
          {!hide && (
            <Button
              endIcon={<Add />}
              onClick={addNewFacility}
              disabled={
                disabled ||
                !formData.waterWithDrawalConsumptionAndDischarg[
                  formData.waterWithDrawalConsumptionAndDischarg.length - 1
                ]?.facilityName
              }
              sx={{
                color: "#fff",
                width: "15rem",
                borderColor: "#1C486B",
                marginTop: "-0.8rem",
                height: "2.5rem",
                marginLeft: "1rem",
                textTransform: "none",
                backgroundColor: "#1C486B",
                "&:hover": {
                  backgroundColor: "#ffffff",
                  color: "#000000", // optional: change on hover if needed
                },
                "&.Mui-disabled": {
                  color: "#ffffff", // maintain white text when disabled
                  border: "1px solid white", // keep border
                  opacity: 0.5, // optional: indicate disabled visually
                },
              }}
              variant="outlined"
            >
              Add Another Facility
            </Button>
          )}
        </Box>

        <li style={{ "text-indent": 0 }} className={style.question_title}>
          Indicate if any independent assessment/ evaluation/assurance has been
          carried out by an external agency? If yes, name of the external
          agency.
        </li>
        <Box sx={{ margin: "0.5rem 0.3rem" }}>
          <ReusableRadioGroup
            disabled={disabled}
            name="waterIndependantAssessment.action"
            value={formData?.waterIndependantAssessment?.action}
            onChange={(e) =>
              handleRadioChange(
                "waterIndependantAssessment.action",
                e.target.value,
              )
            }
            labels={{ yes: "Yes", no: "No" }}
          />
        </Box>
        {formData?.waterIndependantAssessment?.action && (
          <Box
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.8rem",
              marginBottom: "1rem",
            }}
          >
            <p className={style.question_title}>Name of External Agency</p>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              {formData.waterIndependantAssessment.name?.map((name, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <TextField
                    size="small"
                    disabled={disabled}
                    sx={{ width: "26rem", marginTop: "-0.8rem" }}
                    placeholder="Enter Name Here"
                    // value={formData.waterIndependantAssessment.name}
                    value={name}
                    multiline
                    onChange={(e) =>
                      handleTextFieldChange(
                        "waterIndependantAssessment.name",
                        index,
                        e.target.value,
                      )
                    }
                    error={!!errorMessages.waterIndependantAssessment?.[index]}
                    helperText={
                      <Typography
                        variant="body2"
                        color="error"
                        style={{
                          lineHeight: "1.2",
                          marginLeft: "-1rem",
                          color: "#d34040",
                          fontSize: "10px",
                          fontStyle: "italic",
                        }}
                      >
                        {errorMessages.waterIndependantAssessment?.[index] ||
                          ""}
                      </Typography>
                    }
                  />
                  {formData.waterIndependantAssessment.name.length > 1 && (
                    <IconButton
                      disabled={disabled}
                      color="error"
                      onClick={() =>
                        handleRemoveField(
                          "waterIndependantAssessment.name",
                          index,
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  )}
                </Box>
              ))}

              {!hide && (
                <Button
                  // disabled={isFilleds || false}
                  startIcon={<Add />}
                  onClick={() =>
                    handleAddField("waterIndependantAssessment.name")
                  }
                  disabled={
                    formData.waterIndependantAssessment.name[
                      formData.waterIndependantAssessment.name.length - 1
                    ] === "" || disabled
                  } // Disable if the last field is empty
                  sx={{
                    color: "#1C486B",
                    width: "9rem",
                    borderColor: "#1C486B",
                    marginTop: "-1rem",
                    height: "2.5rem",
                  }}
                  variant="outlined"
                >
                  Add Field
                </Button>
              )}
            </Box>
          </Box>
        )}

        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "waterWithDrawalConsumptionAndDischargDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            2. Please provide details of total Scope 3 emissions & its
            intensity, in the following format:
          </p>
          <TableContainer
            component={Paper}
            sx={{
              mt: "-0.5rem",
              mb: "1rem",
              width: "98%",
              marginLeft: "1rem",
              borderRadius: "10px",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1E4976", color: "#fff" }}>
                  {[
                    { label: "S No.", colSpan: 1 },
                    { label: "Category", colSpan: 1 },
                    { label: "In Current Financial Year", colSpan: 1 },
                    { label: "In Previous Financial Year", colSpan: 1 },
                  ].map((heading, index) => (
                    <TableCell
                      key={index}
                      sx={{
                        color: "#fff",
                        fontWeight: "bold",
                        textAlign: "left",
                        border: "1px solid #ddd",
                      }}
                      colSpan={heading.colSpan}
                    >
                      {heading.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {dataKeysEmission.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ border: "1px solid #ddd" }}>
                      {index + 1}
                    </TableCell>
                    <TableCell>{item.label}</TableCell>

                    {[
                      "currentFinancialYear",
                      // "currentUnit",
                      "previousFinancialYear",
                      // "previousUnit",
                    ].map((field, subIndex) => (
                      <TableCell
                        key={subIndex}
                        sx={{ border: "1px solid #ddd" }}
                      >
                        {field.includes("Unit") ? (
                          <Select
                            fullWidth
                            size="small"
                            disabled={disabled}
                            value={
                              formData.scope3EmissionIntensity[item.key][field]
                            }
                            onChange={(e) =>
                              handleInputChangeEmission(
                                `scope3EmissionIntensity.${item.key}.${field}`,
                                e.target.value,
                              )
                            }
                            className={styles["dynamic-select-input"]}
                            displayEmpty
                          >
                            <MenuItem value="">Select Unit</MenuItem>
                            <MenuItem value="Mt CO2 eq">Mt CO2 eq</MenuItem>
                            <MenuItem value="unit">Unit</MenuItem>
                          </Select>
                        ) : (
                          <TextField
                            fullWidth
                            size="small"
                            disabled={disabled}
                            // sx={{ width: "50%" }}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault();
                              }
                            }}
                            placeholder="Type Here"
                            variant="standard"
                            InputProps={{
                              disableUnderline: true,
                              className: "textField",
                            }}
                            value={
                              formData?.scope3EmissionIntensity?.[item?.key]?.[
                                field
                              ] ?? 0
                            }
                            onChange={(e) =>
                              handleInputChangeEmission(
                                `scope3EmissionIntensity.${item.key}.${field}`,
                                e.target.value,
                              )
                            }
                          />
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <li style={{ "text-indent": 0 }} className={style.question_title}>
          If any independent assessment/ evaluation/assurance has been carried
          out by an external agency? (Yes / No)
        </li>
        <Box sx={{ margin: "0.5rem 0.3rem" }}>
          <ReusableRadioGroup
            name="externalAgency.action"
            disabled={disabled}
            value={formData?.externalAgency?.action}
            onChange={(e) =>
              handleRadioChange("externalAgency.action", e.target.value)
            }
            labels={{ yes: "Yes", no: "No" }}
          />
        </Box>
        {formData?.externalAgency?.action && (
          <Box
            sx={{
              marginLeft: "1rem",
              marginTop: "-0.8rem",
              marginBottom: "1rem",
            }}
          >
            <p className={style.question_title}>Name of External Agency</p>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                flexWrap: "wrap",
              }}
            >
              {formData.externalAgency.name?.map((name, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <TextField
                    size="small"
                    disabled={disabled}
                    sx={{ width: "26rem", marginTop: "-0.8rem" }}
                    placeholder="Enter Name Here"
                    // value={formData.externalAgency.name}
                    value={name}
                    multiline
                    onChange={(e) =>
                      handleTextFieldChange(
                        "externalAgency.name",
                        index,
                        e.target.value,
                      )
                    }
                    error={!!errorMessages.externalAgency?.[index]}
                    helperText={
                      <Typography
                        variant="body2"
                        color="error"
                        style={{
                          lineHeight: "1.2",
                          marginLeft: "-1rem",
                          color: "#d34040",
                          fontSize: "10px",
                          fontStyle: "italic",
                        }}
                      >
                        {errorMessages.externalAgency?.[index] || ""}
                      </Typography>
                    }
                  />
                  {formData.externalAgency.name.length > 1 && (
                    <IconButton
                      color="error"
                      disabled={disabled}
                      onClick={() =>
                        handleRemoveField("externalAgency.name", index)
                      }
                    >
                      <Delete />
                    </IconButton>
                  )}
                </Box>
              ))}

              {!hide && (
                <Button
                  // disabled={isFilleds || false}
                  startIcon={<Add />}
                  onClick={() => handleAddField("externalAgency.name")}
                  disabled={
                    formData.externalAgency.name[
                      formData.externalAgency.name.length - 1
                    ] === "" || disabled
                  } // Disable if the last field is empty
                  sx={{
                    color: "#1C486B",
                    width: "9rem",
                    borderColor: "#1C486B",
                    marginTop: "-1rem",
                    height: "2.5rem",
                  }}
                  variant="outlined"
                >
                  Add Field
                </Button>
              )}
            </Box>
          </Box>
        )}
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "scope3EmissionIntensityDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            3. With respect to the ecologically sensitive areas reported at
            Question 11 of Essential Indicators above, provide details of
            significant direct & indirect impact of the entity on biodiversity
            in such areas along-with prevention and remediation activities.
          </p>
          <p
            className={style.question_subtitle}
            style={{ margin: "-0.5rem 1rem -0.1rem 1rem" }}
          >
            Enter Details
          </p>
          <TextField
            minRows={3}
            disabled={disabled}
            multiline
            style={{
              width: "99%",
              padding: "8px",
              marginTop: "0.2rem",
              marginLeft: "0.5rem",
              background: "transparent",
              // border: "1px solid #74757E",
              borderRadius: "4px",
            }}
            placeholder="Type Here"
            value={formData.bioDiversityPrevention}
            onChange={(e) =>
              setFormData({
                ...formData,
                bioDiversityPrevention: e.target.value,
              })
            }
            error={!!validationErrors.bioDiversityPrevention}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {validationErrors?.bioDiversityPrevention}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "bioDiversityPreventionDoc",
            ml: 2,
            removeUpload,
          }}
        />
        {downloadMode && <Box sx={{ pageBreakBefore: "always" }}></Box>}
        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            4. If the entity has undertaken any specific initiatives or used
            innovative technology or solutions to improve resource efficiency,
            or reduce impact due to emissions / effluent discharge / waste
            generated, please provide details of the same as well as outcome of
            such initiatives, as per the following format:
          </p>
          <TableContainer
            component={Paper}
            sx={{
              mt: "-0.5rem",
              borderRadius: "10px",
              marginLeft: "1rem",
              width: "98%",
            }}
          >
            <Table>
              <TableHead>
                <TableRow sx={{ backgroundColor: "#1E4976", color: "#fff" }}>
                  {/* S No. */}
                  <TableCell
                    rowSpan={2}
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      textAlign: "left",
                      border: "1px solid #ddd",
                      width: "6rem",
                      minWidth: "6rem",
                    }}
                  >
                    S. No.
                  </TableCell>

                  {/* Initiative undertaken */}
                  <TableCell
                    rowSpan={2}
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      textAlign: "left",
                      border: "1px solid #ddd",
                    }}
                  >
                    Initiative undertaken
                  </TableCell>

                  {/* Details of the initiative */}
                  <TableCell
                    colSpan={2}
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      textAlign: "left",
                      border: "1px solid #ddd",
                    }}
                  >
                    Details of the initiative
                  </TableCell>

                  {/* Outcome of the initiative */}
                  <TableCell
                    rowSpan={2}
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      textAlign: "left",
                      border: "1px solid #ddd",
                    }}
                  >
                    Outcome of the initiative
                  </TableCell>
                  <TableCell
                    rowSpan={2}
                    sx={{
                      color: "#fff",
                      fontWeight: "bold",
                      textAlign: "left",
                      border: "1px solid #ddd",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>

                {/* Sub-headers for "Details of the initiative" */}
                <TableRow sx={{ backgroundColor: "#1E4976", color: "#fff" }}>
                  <TableCell
                    sx={{
                      border: "1px solid #ddd",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    Summary
                  </TableCell>
                  <TableCell
                    sx={{
                      border: "1px solid #ddd",
                      color: "#fff",
                      fontWeight: "bold",
                    }}
                  >
                    Web-link, if any
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {formData.spcificIntiativesorUsedInnovative.map(
                  (row, index) => (
                    <TableRow key={index}>
                      {/* Static S No */}
                      <TableCell
                        sx={{
                          border: "1px solid #ddd",
                          textAlign: "center",
                          width: "6rem",
                          minWidth: "6rem",
                        }}
                      >
                        <CustomTextField
                          disabled={disabled}
                          value={`${index + 1}.`}
                          placeholder="Type Here"
                          onChange={() => {}}
                        />
                      </TableCell>

                      {/* Dynamic Cells Based on dataKeys */}
                      {dataKeys.map((key) => (
                        <TableCell
                          key={key}
                          sx={{
                            border: "1px solid #ddd",
                          }}
                        >
                          <CustomTextField
                            disabled={disabled}
                            value={row[key]}
                            placeholder="Type Here"
                            onChange={(e) =>
                              handleInputChange1(
                                "spcificIntiativesorUsedInnovative",
                                index,
                                key,
                                e.target.value,
                              )
                            }
                          />
                        </TableCell>
                      ))}
                      <TableCell sx={{ width: "8%" }}>
                        <IconButton
                          disabled={
                            formData.spcificIntiativesorUsedInnovative
                              ?.length === 1 || disabled
                          }
                          // onClick={() => handleRemoveRow(index)}
                          onClick={() =>
                            handleDeleteRow(
                              "spcificIntiativesorUsedInnovative",
                              index,
                              [
                                "intiativeundertaken",
                                "detail",
                                "webLink",
                                "outCome",
                              ],
                            )
                          }
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ),
                )}
              </TableBody>
            </Table>
          </TableContainer>

          {!hide && (
            <Box
              sx={{ display: "flex", justifyContent: "flex-end", mt: 2, mr: 2 }}
            >
              <Button
                disabled={
                  disabled ||
                  // Disable if the last entry has any required field empty
                  (() => {
                    const last =
                      formData.spcificIntiativesorUsedInnovative[
                        formData.spcificIntiativesorUsedInnovative.length - 1
                      ];
                    if (!last) return false;
                    const requiredKeys = [
                      "intiativeundertaken",
                      "detail",
                      "webLink",
                      "outCome",
                    ];
                    return requiredKeys.some(
                      (k) => !String(last[k] || "").trim(),
                    );
                  })()
                }
                startIcon={<Add />}
                onClick={addNewInitiative}
                sx={{
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                  textTransform: "none",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
          )}
          {errors?.spcificIntiativesorUsedInnovative && (
            <Typography
              variant="body2"
              color="error"
              sx={{ mt: 1, ml: 2, fontSize: "12px" }}
            >
              {errors?.spcificIntiativesorUsedInnovative}
            </Typography>
          )}
        </Box>

        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "spcificIntiativesorUsedInnovativeDoc",
            ml: 2,
            removeUpload,
          }}
        />
        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            5. Does the entity have a business continuity and disaster
            management plan? Give details in 100 words / web link.
          </p>
          <FormControl component="fieldset">
            <RadioGroup
              name="busineessDisasterPlan"
              disabled={disabled}
              value={formData?.busineessDisasterPlan?.action ? "yes" : "no"}
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "10px",
                marginTop: "-10px",
                margin: "-10px 0px 10px 12px",
              }}
              onChange={(e) => {
                const value = e.target.value === "yes";
                setFormData((prevFormData) => ({
                  ...prevFormData,
                  busineessDisasterPlan: {
                    ...prevFormData.busineessDisasterPlan,
                    action: value,
                  },
                }));
              }}
            >
              <FormControlLabel
                value="yes"
                control={<Radio disabled={disabled} />}
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={<Radio disabled={disabled} />}
                label="No"
              />
            </RadioGroup>
          </FormControl>

          {/* Show only if 'Yes' is selected */}
          {formData?.busineessDisasterPlan?.action && (
            <>
              <Box sx={{ marginLeft: "1rem" }}>
                <p className={style.question_subtitle}>Web Link (if any)</p>
                <TextField
                  size="small"
                  disabled={disabled}
                  sx={{ width: "100%", marginTop: "-1rem" }}
                  placeholder="Type Here"
                  value={formData.busineessDisasterPlan.webLink}
                  onChange={(e) => {
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      busineessDisasterPlan: {
                        ...prevFormData.busineessDisasterPlan,
                        webLink: e.target.value,
                      },
                    }));
                    setValidationErrors((prevErrors) => ({
                      ...prevErrors,
                      webLink: true,
                    }));
                  }}
                  error={validationErrors.webLink}
                  helperText={
                    validationErrors.webLink && (
                      <Typography
                        variant="body2"
                        color="error"
                        style={{
                          lineHeight: "1.2",
                          marginLeft: "-1rem",
                          color: "#d34040",
                          fontSize: "10px",
                          fontStyle: "italic",
                        }}
                      >
                        {validationErrors.webLink}
                      </Typography>
                    )
                  }
                />
                <p
                  className={style.question_subtitle}
                  style={{ marginBottom: "-0.5rem", marginTop: "1rem" }}
                >
                  Enter Details
                </p>
              </Box>

              <TextField
                minRows={3}
                multiline
                disabled={disabled}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginLeft: "0.5rem",
                  background: "transparent",
                  borderRadius: "4px",
                }}
                placeholder="Type Here"
                value={formData.busineessDisasterPlan.remark}
                onChange={(e) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    busineessDisasterPlan: {
                      ...prevFormData.busineessDisasterPlan,
                      remark: e.target.value,
                    },
                  }));
                  setValidationErrors((prevErrors) => ({
                    ...prevErrors,
                    remark: false, // Clear validation error when user types
                  }));
                }}
                error={validationErrors.remark}
                helperText={
                  validationErrors.remark && (
                    <Typography
                      variant="body2"
                      color="error"
                      style={{
                        lineHeight: "1.2",
                        marginLeft: "-1rem",
                        color: "#d34040",
                        fontSize: "10px",
                        fontStyle: "italic",
                      }}
                    >
                      This field is required
                    </Typography>
                  )
                }
              />
            </>
          )}
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "busineessDisasterPlanDoc",
            ml: 2,
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            6. Disclose any significant adverse impact to the environment,
            arising from the value chain of the entity. What mitigation or
            adaptation measures have been taken by the entity in this regard.
          </p>
          <p className={style.question_subtitle} style={{ marginLeft: "1rem" }}>
            Enter Details
          </p>
          <TextField
            minRows={3}
            disabled={disabled}
            multiline
            style={{
              width: "100%",
              padding: "8px",
              background: "transparent",
              borderRadius: "4px",
              marginLeft: "0.5rem",
              marginTop: "-1rem",
            }}
            placeholder="Type Here"
            value={formData.disCloseAdverseImpactEnvironment}
            onChange={(e) => {
              setFormData((prevFormData) => ({
                ...prevFormData,
                disCloseAdverseImpactEnvironment: e.target.value,
              }));
            }}
            error={!!validationErrors.disCloseAdverseImpactEnvironment}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {validationErrors.disCloseAdverseImpactEnvironment}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "disCloseDoc",
            ml: 2,
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            7. Percentage of value chain partners (by value of business done
            with such partners) that were assessed for environmental impacts.
          </p>
          <TextField
            size="small"
            disabled={disabled}
            sx={{ width: "50%", marginLeft: "1rem", marginTop: "-0.5rem" }}
            placeholder="Type Here"
            value={formData.valueChainPartnerAssessment}
            onChange={(e) =>
              setFormData((prevFormData) => ({
                ...prevFormData,
                valueChainPartnerAssessment: e.target.value,
              }))
            }
            error={!!validationErrors.valueChainPartnerAssessment}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {validationErrors.valueChainPartnerAssessment}
              </Typography>
            }
          />
        </Box>
        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "valueChainDoc",
            ml: 2,
            removeUpload,
          }}
        />

        <Box sx={{ mb: 3 }}>
          <p className={style.question_title}>
            8. How many Green Credits have been generated or procured.
          </p>
          <p
            className={style.question_title}
            style={{ marginLeft: "1rem", marginTop: "-0.5rem" }}
          >
            a. By the listed entity
          </p>
          <TextField
            size="small"
            disabled={disabled}
            sx={{ width: "50%", marginLeft: "1rem", marginTop: "-0.5rem" }}
            placeholder="Enter Number Here"
            value={formData.greenCreditsByEntityCount}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              setFormData((prevFormData) => ({
                ...prevFormData,
                greenCreditsByEntityCount: value,
              }));
            }}
            error={!!validationErrors.greenCreditsByEntityCount}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {validationErrors.greenCreditsByEntityCount}
              </Typography>
            }
          />

          <TextField
            name="greenCreditsByEntityRemark"
            value={formData.greenCreditsByEntityRemark}
            onChange={(e) =>
              setFormData((prevFormData) => ({
                ...prevFormData,
                greenCreditsByEntityRemark: e.target.value,
              }))
            }
            fullWidth
            size="small"
            placeholder="Enter additional text for details"
            multiline
            rows={3}
            disabled={disabled}
            sx={{ marginLeft: "1rem", width: "98%" }}
            error={!!errors.greenCreditsByEntityRemark}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-1rem",
                }}
              >
                {errors.greenCreditsByEntityRemark || ""}
              </Typography>
            }
          />

          <p
            className={style.question_title}
            style={{ marginLeft: "1rem", marginTop: "0.75rem" }}
          >
            b. By the top ten (in terms of value of purchases and sales,
            respectively) value chain partners
          </p>
          <TextField
            size="small"
            disabled={disabled}
            sx={{ width: "50%", marginLeft: "1rem", marginTop: "-0.5rem" }}
            placeholder="Enter Number Here"
            value={formData.greenCreditsByValueChainPartnerCount}
            onChange={(e) => {
              const value = e.target.value.replace(/[^0-9]/g, "");
              setFormData((prevFormData) => ({
                ...prevFormData,
                greenCreditsByValueChainPartnerCount: value,
              }));
            }}
            error={!!validationErrors.greenCreditsByValueChainPartnerCount}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-10px",
                }}
              >
                {validationErrors.greenCreditsByValueChainPartnerCount}
              </Typography>
            }
          />

          <TextField
            name="greenCreditsByValueChainPartnerRemark"
            value={formData.greenCreditsByValueChainPartnerRemark}
            onChange={(e) =>
              setFormData((prevFormData) => ({
                ...prevFormData,
                greenCreditsByValueChainPartnerRemark: e.target.value,
              }))
            }
            fullWidth
            size="small"
            placeholder="Enter additional text for details"
            multiline
            rows={3}
            disabled={disabled}
            sx={{ marginLeft: "1rem", width: "98%" }}
            error={!!errors.greenCreditsByValueChainPartnerRemark}
            helperText={
              <Typography
                variant="body2"
                color="error"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                  marginLeft: "-1rem",
                }}
              >
                {errors.greenCreditsByValueChainPartnerRemark || ""}
              </Typography>
            }
          />
        </Box>

        <BRSRFile
          {...{
            modalupload,
            setModalUpload,
            formData,
            setFormData,
            errors,
            setErrors,
            Uploadkey: "greenCreditsDoc",
            ml: 2,
            removeUpload,
          }}
        />
      </Box>

      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98.4%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 2, mb: 5 }}
                onClick={handleSubmit}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
      <Snackbar
        open={snackOpen.open}
        message={snackOpen.message}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setsnackOpen({ ...snackOpen, open: false })}
      >
        <Alert
          severity={snackOpen.severity || "info"} // Ensure a default severity if undefined
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackOpen.message || "No message provided"}
        </Alert>
      </Snackbar>
    </>
  );
};

export default LeadershipIndicator;
